import React, { useState, useRef, useEffect } from 'react';

const audioSources = [
    {
        name: 'Atlas',
        url: 'https://firebasestorage.googleapis.com/v0/b/speechsdk.appspot.com/o/voices%2Fvoice_k060u01h%2FConverstional%2Foutput_1.wav?alt=media&token=a4a50b19-7d04-4387-8ef0-29e1a7b6f429',
        words: [
            { word: "Oh", start: 0.16 }, { word: "my", start: 0.4 }, { word: "God.", start: 0.56 },
            { word: "So,", start: 0.96 }, { word: "I", start: 1.28 }, { word: "ran", start: 1.44 },
            { word: "into", start: 1.68 }, { word: "Jake", start: 1.92 }, { word: "at", start: 2.32 },
            { word: "the", start: 2.4 }, { word: "grocery", start: 2.48 }, { word: "store", start: 3.04 },
            { word: "and", start: 3.6 }, { word: "he", start: 3.92 }, { word: "was", start: 4.08 },
            { word: "asking", start: 4.24 }, { word: "about", start: 4.72 }, { word: "you.", start: 4.88 },
            { word: "It", start: 5.44 }, { word: "was", start: 5.6 }, { word: "kind", start: 5.84 },
            { word: "of", start: 6.0 }, { word: "awkward,", start: 6.16 }, { word: "honestly.", start: 6.64 },
            { word: "I", start: 7.2 }, { word: "just", start: 7.28 }, { word: "said", start: 7.44 },
            { word: "you", start: 7.6 }, { word: "were", start: 7.76 }, { word: "doing", start: 7.92 },
            { word: "well", start: 8.16 }, { word: "and", start: 8.48 }, { word: "left", start: 8.72 },
            { word: "it", start: 8.96 }, { word: "at", start: 9.12 }, { word: "that.", start: 9.2 }
        ]
    },
    {
        name: 'Atlas',
        url: 'https://firebasestorage.googleapis.com/v0/b/speechsdk.appspot.com/o/voices%2Fvoice_k060u01h%2FConverstional%2Foutput_2.wav?alt=media&token=68728f0d-0908-4873-9df6-86c0f19432e6',
        words: [
            { word: "So", start: 0.24 }, { word: "I", start: 0.72 }, { word: "was", start: 0.88 },
            { word: "thinking", start: 1.12 }, { word: "we", start: 1.44 }, { word: "could", start: 1.6 },
            { word: "do", start: 1.76 }, { word: "Thai", start: 1.92 }, { word: "food", start: 2.24 },
            { word: "tonight.", start: 2.64 }, { word: "There's", start: 3.2 }, { word: "that", start: 3.52 },
            { word: "new", start: 3.68 }, { word: "place", start: 3.92 }, { word: "on", start: 4.16 },
            { word: "Fifth", start: 4.32 }, { word: "that", start: 4.8 }, { word: "everyone's", start: 4.88 },
            { word: "been", start: 5.36 }, { word: "talking", start: 5.52 }, { word: "about.", start: 5.84 },
            { word: "Or", start: 6.64 }, { word: "we", start: 7.04 }, { word: "could", start: 7.2 },
            { word: "just", start: 7.44 }, { word: "do", start: 7.6 }, { word: "pizza", start: 7.76 },
            { word: "again", start: 8.4 }, { word: "if", start: 8.64 }, { word: "you're", start: 8.72 },
            { word: "not", start: 9.04 }, { word: "feeling", start: 9.2 }, { word: "adventurous.", start: 9.36 }
        ]
    },
    {
        name: 'Summer',
        url: 'https://firebasestorage.googleapis.com/v0/b/speechsdk.appspot.com/o/voices%2Fvoice_bayr5804%2FConversational%2Foutput_4.wav?alt=media&token=c955e233-f890-4c30-96a4-2b09c2a9ce39',
        words: [
            { word: "Honestly", start: 0.08 }, { word: "the", start: 0.64 }, { word: "movie", start: 0.72 },
            { word: "was", start: 1.04 }, { word: "fine,", start: 1.2 }, { word: "like", start: 1.52 },
            { word: "it", start: 1.84 }, { word: "wasn't", start: 2.0 }, { word: "bad,", start: 2.48 },
            { word: "but", start: 2.88 }, { word: "it", start: 3.04 }, { word: "wasn't", start: 3.12 },
            { word: "great", start: 3.6 }, { word: "either.", start: 3.92 }, { word: "I", start: 4.72 },
            { word: "think", start: 4.88 }, { word: "I", start: 5.04 }, { word: "just", start: 5.28 },
            { word: "expected", start: 5.52 }, { word: "more", start: 6.0 }, { word: "from", start: 6.24 },
            { word: "the", start: 6.4 }, { word: "director", start: 6.56 }, { word: "after", start: 7.12 },
            { word: "his", start: 7.36 }, { word: "last", start: 7.52 }, { word: "one,", start: 7.76 }
        ]
    },
    {
        name: 'Summer',
        url: 'https://firebasestorage.googleapis.com/v0/b/speechsdk.appspot.com/o/voices%2Fvoice_bayr5804%2FConversational%2Foutput_3.wav?alt=media&token=2b886a9c-5809-4eda-8361-87c70b44b0aa',
        words: [
            { word: "Yeah", start: 0.08 }, { word: "no", start: 0.56 }, { word: "I", start: 0.72 },
            { word: "totally", start: 0.88 }, { word: "get", start: 1.28 }, { word: "it.", start: 1.44 },
            { word: "Work's", start: 1.76 }, { word: "been", start: 2.32 }, { word: "insane", start: 2.64 },
            { word: "for", start: 3.12 }, { word: "me", start: 3.28 }, { word: "too", start: 3.52 },
            { word: "lately.", start: 3.84 }, { word: "I've", start: 4.72 }, { word: "barely", start: 5.04 },
            { word: "had", start: 5.44 }, { word: "time", start: 5.6 }, { word: "to", start: 5.84 },
            { word: "even", start: 6.0 }, { word: "watch", start: 6.24 }, { word: "anything.", start: 6.56 },
            { word: "My", start: 7.28 }, { word: "Netflix", start: 7.52 }, { word: "queue", start: 8.24 },
            { word: "is", start: 8.64 }, { word: "just", start: 8.72 }, { word: "piling", start: 8.96 },
            { word: "up...", start: 9.28 }
        ]
    },
];

const OFFSET = 0.3;

function Confidential() {
    const [activeIndex, setActiveIndex] = useState(null);
    const [audioProgress, setAudioProgress] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [videoProgress, setVideoProgress] = useState(0);
    const [videoPlaying, setVideoPlaying] = useState(false);
    const [videoHovered, setVideoHovered] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const audioRef = useRef(null);
    const videoRef = useRef(null);
    const wordsRef = useRef([]);

    useEffect(() => {
        const timer = setTimeout(() => setShowPopup(true), 5000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        let animationId;
        const updateProgress = () => {
            if (audio.duration) {
                setAudioProgress((audio.currentTime / audio.duration) * 100);
                setCurrentTime(audio.currentTime);
            }
            animationId = requestAnimationFrame(updateProgress);
        };

        const handleEnded = () => {
            setActiveIndex(null);
            setAudioProgress(0);
            setCurrentTime(0);
            cancelAnimationFrame(animationId);
        };

        const handlePlay = () => { animationId = requestAnimationFrame(updateProgress); };
        const handlePause = () => { cancelAnimationFrame(animationId); };

        audio.addEventListener('play', handlePlay);
        audio.addEventListener('pause', handlePause);
        audio.addEventListener('ended', handleEnded);

        return () => {
            cancelAnimationFrame(animationId);
            audio.removeEventListener('play', handlePlay);
            audio.removeEventListener('pause', handlePause);
            audio.removeEventListener('ended', handleEnded);
        };
    }, [activeIndex]);

    const handlePlay = (index) => {
        if (activeIndex === index) {
            audioRef.current?.pause();
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
            setAudioProgress(0);
            setCurrentTime(0);
        }
    };

    useEffect(() => {
        if (activeIndex !== null && audioRef.current) {
            audioRef.current.play();
        }
    }, [activeIndex]);

    useEffect(() => {
        const words = wordsRef.current;
        const time = currentTime + OFFSET;
        words.forEach((el, i) => {
            if (!el) return;
            el.classList.remove('round-l', 'round-r');
            if (time < audioSources[activeIndex]?.words[i]?.start) return;
            const prev = words[i - 1];
            const next = words[i + 1];
            const prevActive = prev && time >= audioSources[activeIndex]?.words[i - 1]?.start;
            const nextActive = next && time >= audioSources[activeIndex]?.words[i + 1]?.start;
            if (!prevActive || el.offsetTop > prev.offsetTop) el.classList.add('round-l');
            if (!nextActive || (next && next.offsetTop > el.offsetTop)) el.classList.add('round-r');
        });
    }, [currentTime, activeIndex]);

    const handleAudioSeek = (e) => {
        if (!audioRef.current) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const percent = (e.clientX - rect.left) / rect.width;
        audioRef.current.currentTime = percent * audioRef.current.duration;
    };

    const handleVideoToggle = () => {
        if (!videoRef.current) return;
        if (videoPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setVideoPlaying(!videoPlaying);
    };

    const handleVideoSeek = (e) => {
        if (!videoRef.current) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const percent = (e.clientX - rect.left) / rect.width;
        videoRef.current.currentTime = percent * videoRef.current.duration;
    };

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        let animationId;
        const updateProgress = () => {
            if (video.duration) {
                setVideoProgress((video.currentTime / video.duration) * 100);
            }
            animationId = requestAnimationFrame(updateProgress);
        };

        const handleEnded = () => {
            setVideoPlaying(false);
            setVideoProgress(0);
            cancelAnimationFrame(animationId);
        };

        const handlePlay = () => { animationId = requestAnimationFrame(updateProgress); };
        const handlePause = () => { cancelAnimationFrame(animationId); };

        video.addEventListener('play', handlePlay);
        video.addEventListener('pause', handlePause);
        video.addEventListener('ended', handleEnded);

        return () => {
            cancelAnimationFrame(animationId);
            video.removeEventListener('play', handlePlay);
            video.removeEventListener('pause', handlePause);
            video.removeEventListener('ended', handleEnded);
        };
    }, []);

    return (
        <div className="min-h-screen w-screen flex flex-col md:flex-row bg-white overflow-auto max-w-screen-2xl mx-auto">
            {/* Popup */}
            {showPopup && (
                <div className="fixed top-6 right-6 bg-white border border-gray-200 rounded-xl p-4 pr-10 shadow-sm max-w-xs z-50 animate-fade-in">
                    <button
                        onClick={() => setShowPopup(false)}
                        className="absolute top-3 right-3 text-gray-300 hover:text-gray-500 transition-colors"
                    >
                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                    </button>
                    <p className="text-sm text-gray-600">All of this can be generated in real-time for back-and-forth conversation.</p>
                </div>
            )}

            {activeIndex !== null && (
                <audio ref={audioRef} src={audioSources[activeIndex].url} />
            )}

            {/* Top/Left: Orpheus (Voice) */}
            <div className="w-full md:w-1/2 h-screen md:h-auto flex flex-col">
                <div className="p-6 md:p-8 group">
                    <p className="text-xs text-gray-400 tracking-wide cursor-default">Orpheus</p>
                    <p className="text-xs text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-500">a text-to-speech model</p>
                </div>

                <div className="flex-1 flex flex-col justify-center px-12 md:px-32">
                    {/* Content container - matches video height */}
                    <div className="relative h-[500px]">
                        {/* Text display */}
                        <div>
                            {activeIndex !== null ? (
                                <p className="text-sm leading-relaxed">
                                    {audioSources[activeIndex].words.map((w, i) => (
                                        <span
                                            key={i}
                                            ref={el => wordsRef.current[i] = el}
                                            onClick={() => { if (audioRef.current) { audioRef.current.currentTime = w.start; audioRef.current.play(); } }}
                                            className={`inline py-0.5 px-0.5 cursor-pointer transition-colors ${
                                                currentTime + OFFSET >= w.start ? 'bg-black/10' : ''
                                            } hover:bg-black/20`}
                                        >
                                            {w.word}{' '}
                                        </span>
                                    ))}
                                </p>
                            ) : (
                                <p className="text-gray-400 text-sm">Select audio to play</p>
                            )}
                        </div>

                        {/* Pills - positioned at bottom above progress bar */}
                        <div className="absolute bottom-8 left-0 flex flex-wrap gap-3">
                            {audioSources.map((source, i) => (
                                <button
                                    key={i}
                                    onClick={() => handlePlay(i)}
                                    className={`px-4 py-2 text-sm rounded-full transition-colors ${
                                        activeIndex === i
                                            ? 'bg-gray-700 text-white'
                                            : 'bg-black text-white hover:bg-gray-800'
                                    }`}
                                >
                                    {source.name}
                                </button>
                            ))}
                        </div>

                        {/* Progress bar - aligned with video progress bar at bottom-3 */}
                        <div
                            className="absolute bottom-3 left-0 right-0 h-1 bg-gray-100 rounded-full cursor-pointer"
                            onClick={handleAudioSeek}
                        >
                            <div
                                className="h-full bg-gray-400 rounded-full"
                                style={{ width: `${audioProgress}%` }}
                            />
                        </div>
                    </div>
                </div>

                <div className="p-6 md:p-8" />
            </div>

            {/* Divider - hidden on mobile */}
            <div className="hidden md:flex items-center">
                <div className="w-px h-[75vh] bg-gray-200/70" />
            </div>

            {/* Bottom/Right: Ophelia (Video) */}
            <div className="w-full md:w-1/2 min-h-screen md:min-h-0 md:h-auto flex flex-col">
                <div className="p-6 md:p-8 group">
                    <p className="text-xs text-gray-400 tracking-wide cursor-default">Ophelia</p>
                    <p className="text-xs text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-500">a text-to-video model</p>
                </div>

                <div className="flex-1 flex flex-col justify-center px-6 md:px-16">
                    {/* Video */}
                    <div className="flex items-start justify-center">
                        <div
                            className="relative w-[300px] h-[500px] rounded-2xl overflow-hidden cursor-pointer"
                            onMouseEnter={() => setVideoHovered(true)}
                            onMouseLeave={() => setVideoHovered(false)}
                            onClick={handleVideoToggle}
                        >
                            <video
                                ref={videoRef}
                                className="w-full h-full object-cover"
                                src="https://investor-update-seven.vercel.app/video-examples/27_10_2.mp4"
                                playsInline
                            />

                            {/* Overlay */}
                            <div className={`absolute inset-0 bg-black/30 flex items-center justify-center transition-opacity duration-300 ${videoHovered || !videoPlaying ? 'opacity-100' : 'opacity-0'}`}>
                                <svg className="w-12 h-12 text-white" viewBox="0 0 24 24" fill="currentColor">
                                    {videoPlaying ? (
                                        <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                                    ) : (
                                        <path d="M8 5v14l11-7z" />
                                    )}
                                </svg>
                            </div>

                            {/* Progress bar - inside video */}
                            <div
                                className="absolute bottom-3 left-3 right-3 h-1 bg-white/30 rounded-full"
                                onClick={(e) => { e.stopPropagation(); handleVideoSeek(e); }}
                            >
                                <div
                                    className="h-full bg-white rounded-full"
                                    style={{ width: `${videoProgress}%` }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-6 md:p-8" />
            </div>
        </div>
    );
}

export default Confidential;
